import { ChangeDetectionStrategy, Component, signal } from '@angular/core'

import { ICellRendererAngularComp } from 'ag-grid-angular'
import { ICellRendererParams } from 'ag-grid-community'

import { ApplicationVersion } from '@flowx/designer/shared/entities/application.entity'
import { FlxBranchStateComponent } from '@flowx/designer/shared/versioning/branch-state/branch-state.component'

import { BranchNameComponent } from '../../../versioning/branch-name/branch-name.component'

@Component({
  imports: [BranchNameComponent, FlxBranchStateComponent],
  templateUrl: './application-branch-info.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    class: 'flex items-center gap-2 h-full',
  },
})
export class ApplicationBranchInfoComponent implements ICellRendererAngularComp {
  app = signal<ApplicationVersion>(undefined)
  agInit(params: ICellRendererParams<any, any, any>): void {
    this.app.set(params.data)
  }
  refresh(params: ICellRendererParams<any, any, any>): boolean {
    this.agInit(params)
    return true
  }
}
